import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="unread-badge"
export default class extends Controller {
  static targets = ["container"]
  static values = {counter: Number}

  connect() {
    this.containerTarget.innerHTML = this.counterValue
  }

  async decreaseCounter(){
    if(this.counterValue > 0){
      this.counterValue -= 1
      this.containerTarget.innerHTML = this.counterValue
    }
  }
}
